<template>
  <div>
    <!-- <topnav /> -->
    <div class="approve-container">
      <div class="loading" v-if="loading"><img src="@/assets/loading.gif" /></div>
      <div class="approve-title">
        <button class="hollow-btn" @click="back()">返回</button>
        <!-- <button
          v-if="$route.query.f !== 'exam'"
          :style="{ background: mode === 0 || !isAble ? '#cccccc' : '' }"
          @click="submit()"
          style="width: 100px;margin-left: 30px;"
        >
          {{ imageStatus === 5 ? '有效' : '提交' }}
        </button> -->
        <div class="mode-btn">
          <button
            v-if="taskTypeName === '文本矩形' || taskTypeName === '文本多边形'"
            class="hollow-btn"
            :class="currMode === 'point' ? 'active' : ''"
            @click="
              point();
              currMode = 'point';
            "
          >
            画框模式
          </button>
          <button
            v-if="taskTypeName === '文本矩形' || taskTypeName === '文本多边形'"
            class="hollow-btn"
            :class="currMode === 'words' ? 'active' : ''"
            @click="
              words();
              currMode = 'words';
            "
            :disabled="orgAnnos.length === 0"
          >
            录入模式
          </button>
        </div>
        <button
          v-if="imageStatus === 0 && $route.query.f !== 'exam'"
          @click="deleteImage()"
          style="width: 100px;margin-left: 30px;background: #c05d5d;"
        >
          删除图片
        </button>
        <button
          v-if="$route.query.f === 'exam'"
          @click="removeImageFromExam()"
          style="width: 100px;margin-left: 30px;background: #c05d5d;"
        >
          移除图片
        </button>
        <!-- <div class="anno-belonger" v-if="currAnno.annotator && !currAnno.approver">
          <span>创建人：{{ currAnno.annotator }}</span>
          <span>创建时间：{{ new Date(currAnno.createAt).toLocaleString('chinese', { hour12: false }) }}</span>
          <span>框ID：{{ currAnno.id }}</span>
        </div> -->
        <!-- <div v-if="currAnno.approver">
          <span>审核员：{{ currAnno.approver }}</span>
          <span>修改时间：{{ new Date(currAnno.updateAt).toLocaleString('chinese', { hour12: false }) }}</span>
          <span>框ID：{{ currAnno.id }}</span>
        </div> -->
        <div class="anno-info">
          <span v-if="mode === 0">框ID：{{ currAnno.id }}</span>
          <span v-if="mode === 0">标注员：{{ currAnno.annotator }}</span>
          <span v-if="mode === 0">审核员：{{ currAnno.approverOne }}</span>
          <span v-if="mode === 0">安检员：{{ currAnno.approverTwo }}</span>
          <span v-if="mode === 0">管理员：{{ currAnno.approverThree }}</span>
          <span v-if="currAnno.status == 4" style="color: #ff0000">申诉中</span>
          <span>任务名：{{ taskName }}</span>
          <span v-if="url">图片ID：{{ imageId }}</span>
          <!-- <span v-if="url">图片状态：{{ imageStatusMap[imageStatus] }}</span> -->
          <div class="flip-button">
            <span @click="toPrev()">&lt;</span>
            <span @click="toNext()">&gt;</span>
          </div>
          <div class="anno-search">
            <input v-model="searchImageId" placeholder="图片ID" @keyup.enter="search()" />
            <img @click="search()" src="@/assets/search.png" />
          </div>
        </div>
      </div>
      <div class="approve-content">
        <div class="approve-image">
          <AnnoPanel
            v-if="showPanel"
            :src="url"
            ref="annopanel"
            :annos="annos"
            height="646"
            :style="{ height: taskTypeId !== 3 ? '646px' : '100%', maxHeight: '646px', background: '#fafafa' }"
            :mode="mode"
            scalable
            :separable="taskTypeMap[taskTypeName] !== 2"
            :hidden="taskTypeId !== 3"
            maskColor="transparent"
            @annoClick="annoClick($event)"
          ></AnnoPanel>
          <a class="icp-info" href="https://beian.miit.gov.cn" target="_blank">
            <span>沪ICP备20000777号-1</span>
          </a>
        </div>
        <div class="approve-classes anno-option" v-if="taskTypeName !== '文本矩形' && taskTypeName !== '文本多边形'">
          <div class="category-option" v-for="(item, group) of sortedClassifications" :key="group">
            <span
              class="class-option"
              :class="{ active: currClasses.includes(c.classId), exist: existClasses[c.classId] }"
              v-for="c of item"
              :key="c.classId"
              @click="setClass(0, c.classId)"
            >
              {{ c.className }}{{ existClasses[c.classId] ? `(${existClasses[c.classId]})` : '' }}
            </span>
            <div class="separate-line"></div>
          </div>
        </div>
        <div class="annotate-text anno-option" v-if="taskTypeName === '文本矩形' || taskTypeName === '文本多边形'">
          <textarea v-model="sceneText" :disabled="mode === 1"></textarea>
        </div>
        <div v-show="url && isValid" class="approve-btn">
          <div v-show="mode === 1" v-if="$route.query.f !== 'd'">
            <button @click="newAnno()">新增画框</button>
            <button class="hollow-btn" @click="duokuang()">多框</button>
          </div>
          <div v-show="mode === 0">
            <button :disabled="saveAnnoAble" @click="saveAnno()">保存画框</button>
            <button style="background: #c05d5d;" @click="deleteAnno()">
              {{ getDeleteName() }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import topnav from '@/components/topnav';
import * as api from '@/api/api.js';
import { imageStatusMapAdmin } from '@/config';
import ImageDetail from '@/mixins/imagedetail.js';

export default {
  data: function() {
    return {
      hasAnno: true,
      wordsIndex: 0,
      orgUrl: '',
      currOperation: 'point',
      currMode: 'point',
      searchImageId: null,
      restImageCount: 0,
      imageId: 0,
      imageStatus: 0,
      url: '',
      taskType: null, // AnnoPanel中的标注类型
      taskTypeName: null, // 服务端返回的标注类型
      taskId: null,
      taskName: '',
      imageStatusMap: [],
      annotations: [],
      classifications: [],
      classes: [],
      annos: [],
      orgAnnos: [],
      mode: 1,
      currAnno: {},
      currClasses: [],
      width: 0,
      height: 0,
      isAble: true,
      isValid: true,
      saveAnnoAble: false,
      pageType: 'edit',
      imageList: [],
      sceneText: '',
      loading: false,
      annotator: '',
      approverOne: '',
      approverTwo: '',
      approverThree: '',
    };
  },
  mixins: [ImageDetail],
  watch: {
    $route() {
      this.getNewImage();
    },
  },
  computed: {
    existClasses() {
      // 管理员页面每个类别要显示属于该类别的标注数量
      let result = {};
      this.orgAnnos
        .reduce((total, item) => [...total, ...item.classIds], [])
        .forEach(v => {
          result[v] = result[v] ? result[v] + 1 : 1;
        });
      return result;
    },
    sortedClassifications() {
      if (this.taskTypeName !== '文本矩形' && this.taskTypeName !== '文本多边形') {
        // return this.classifications.map(clf => {
        //   clf.classes = [
        //     ...clf.classes.filter(cls => this.existClasses[cls.classId]),
        //     ...clf.classes.filter(cls => !this.existClasses[cls.classId]),
        //   ];
        //   return clf;
        // });
        // 按照指定顺序排列
        return this.classifications.reduce((pre, cur) => {
          cur.classes.forEach(v => {
            const group = parseInt(v.groupId / 100);
            if (pre[group]) {
              pre[group].push(v);
            } else {
              pre[group] = [v];
            }
          });
          return pre;
        }, {});
      }
      return '';
    },
  },
  mounted: function() {
    this.imageStatusMap = imageStatusMapAdmin;
    this.imageList = this.$store.state.adminImageList;
  },
  beforeDestroy() {
    this.curPage = false;
  },
  methods: {
    duokuang() {
      let anno = {
        pageType: this.pageType,
        taskId: this.$route.params.id ? this.$route.params.id : this.taskId,
        imageid: this.imageId,
        points: [],
        classIds: [],
      };
      anno.annotationId = this.$route.query.aid;
      api
        .saveAnno(anno)
        .then(res => {
          let tmpAnno = {
            id: res.data.id,
            type: this.currAnno.type,
            classIds: this.currClasses,
            data: this.currAnno.data,
            userId: this.$store.state.userId,
          };
          tmpAnno.title = this.sceneText;
          tmpAnno.cat = 0;
          tmpAnno.status = 0;
          this.orgAnnos.push(tmpAnno);
          this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
          this.mode = 1;
          this.currClasses = [];
          this.sceneText = '';
          this.currAnno = {};
          this.saveAnnoAble = false;
        })
        .catch(() => {
          this.saveAnnoAble = false;
        });
    },
    removeImageFromExam() {
      api.removeImageFromExam(this.$route.query.eid, [this.imageId]).then(() => {
        this.$notify({
          group: 'foo',
          type: 'custom-blue',
          text: `删除成功`,
          duration: 1500,
        });
        let index = this.imageList.findIndex(v => v.imageId === this.imageId);
        if (index === this.imageList.length - 1) index--;
        else index++;
        let newImageId = this.imageList[index].imageId;
        this.imageList = this.imageList.filter(v => v.imageId !== this.imageId);
        this.imageId = newImageId;
        this.$router.push({ path: `/image/${this.imageId}`, query: this.$route.query });
      });
    },
    backToViewMode() {
      if (this.mode === 0) {
        this.mode = 1;
        this.currClasses = [];
        this.sceneText = '';
        this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
      } else {
        if (this.hasAnno) {
          this.annos = [];
          this.hasAnno = false;
        } else {
          this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
          this.hasAnno = true;
        }
      }
    },
    // 手动控制第0页不往前翻 向typeorm请求-1页也有结果的
    isBoundary(page) {
      this.$route.query.page = parseInt(this.$route.query.page) + parseInt(page);
      if (this.$route.query.page < 0) {
        this.$route.query.page = 0;
        this.loading = false;
        this.$notify({
          group: 'foo',
          text: '没图啦',
          type: 'custom-yellow',
          duration: 1500,
        });
        return true;
      }
      return false;
    },
    directlySearch(page) {
      if (this.isBoundary(page)) return;
      api
        .directlySearch(this.$route.query)
        .then(res => {
          if (res.data.images.length) {
            this.imageList = res.data.images.map(v => {
              return {
                imageId: v.imageId,
                taskId: v.taskId,
              };
            });
            this.$store.commit('setAdminImageList', { imageList: this.imageList });
            this.$route.query.tid = this.imageList[page > 0 ? 0 : this.imageList.length - 1].taskId;
            this.$router.push({
              path: `/image/${this.imageList[page > 0 ? 0 : this.imageList.length - 1].imageId}`,
              query: this.$route.query,
            });
          } else {
            this.$route.query.page = parseInt(this.$route.query.page) - parseInt(page);
            this.$notify({
              group: 'foo',
              text: '没图啦',
              type: 'custom-yellow',
              duration: 1500,
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getImageByTask(page) {
      if (this.isBoundary(page)) return;
      api
        .getImageList(
          { page: this.$route.query.page, pagesize: this.$route.query.pagesize, status: this.$route.query.status },
          this.$route.query.tid,
        )
        .then(res => {
          if (res.data.images.length) {
            this.imageList = res.data.images.map(v => {
              return {
                imageId: v.id,
                taskId: this.$route.query.tid,
              };
            });
            this.$store.commit('setAdminImageList', { imageList: this.imageList });
            this.$router.push({
              path: `/image/${this.imageList[page > 0 ? 0 : this.imageList.length - 1].imageId}`,
              query: this.$route.query,
            });
          } else {
            this.$route.query.page -= page;
            this.$notify({
              group: 'foo',
              text: '没图啦',
              type: 'custom-yellow',
              duration: 1500,
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    toNext() {
      if (this.currOperation === 'words') return;
      let index = this.imageList.findIndex(v =>
        this.$route.query.tid
          ? v.imageId == this.imageId && v.taskId == this.$route.query.tid
          : v.imageId == this.imageId,
      );
      if (index < this.imageList.length - 1) {
        this.$router.push({
          path: `/image/${this.imageList[index + 1].imageId}`,
          query: { ...this.$route.query, tid: this.imageList[index + 1].taskId },
        });
      } else {
        this.loading = true;
        if (this.$route.query.f === 's') {
          this.directlySearch(1);
        } else if (this.$route.query.f === 'd') {
          this.getImageByTask(1);
        } else if (!this.$route.query.f) {
          // 搜索过图了 url里的参数被清空了
          this.loading = false;
          this.$notify({
            group: 'foo',
            text: '没图啦',
            type: 'custom-yellow',
            duration: 1500,
          });
        }
      }
    },
    toPrev() {
      if (this.currOperation === 'words') return;
      let index = this.imageList.findIndex(v =>
        this.$route.query.tid
          ? v.imageId == this.imageId && v.taskId == this.$route.query.tid
          : v.imageId == this.imageId,
      );
      if (index > 0) {
        this.$router.push({
          path: `/image/${this.imageList[index - 1].imageId}`,
          query: { ...this.$route.query, tid: this.imageList[index - 1].taskId },
        });
      } else {
        this.loading = true;
        if (this.$route.query.f === 's') {
          this.directlySearch(-1);
        } else if (this.$route.query.f === 'd') {
          this.getImageByTask(-1);
        } else {
          // 搜索过图了 url里的参数被清空了
          this.loading = false;
          this.$notify({
            group: 'foo',
            text: '没图啦',
            type: 'custom-yellow',
            duration: 1500,
          });
        }
      }
    },
    back() {
      if (this.$route.query.f === 's') this.$router.push({ path: '/search', query: this.$route.query });
      else if (this.$route.query.f === 'd')
        this.$router.push({ path: `/task/${this.$route.query.tid}`, query: this.$route.query });
      else if (this.$route.query.f === 'exam') this.$router.push({ path: `/editexam/${this.$route.query.eid}` });
      else this.$router.go(-1);
    },
    search() {
      if (this.searchImageId > 0 && this.searchImageId != this.imageId) {
        api
          .getImage({ imageId: this.searchImageId })
          .then(res => {
            if (res.data.id) {
              this.imageList = [];
              this.$router.push({ path: `/image/${this.searchImageId}` });
            }
          })
          .catch(() => {
            this.searchImageId = null;
          });
      }
    },
    annosFormat() {
      this.orgAnnos = this.annotations.map(anno => {
        let tmpAnno = {
          id: anno.id,
          type: this.taskTypeMap[this.taskTypeName],
          data: anno.points,
          userId: anno.userId,
          annotator: anno.annotator,
          approverOne: anno.approverOne,
          approverTwo: anno.approverTwo,
          approverThree: anno.approverThree,
          createAt: anno.createAt,
          updateAt: anno.updateAt,
          status: anno.status,
        };
        if (this.taskTypeName !== '文本矩形' && this.taskTypeName !== '文本多边形') {
          tmpAnno.cat = anno.classes[0].classId;
          tmpAnno.title = (anno.annoStatus === 2 ? '⚠️' : '') + anno.classes.map(item => item.className).join(',');
          tmpAnno.classIds = anno.classes.map(item => item.classId);
        } else {
          tmpAnno.words = anno.words;
          tmpAnno.cat = 0;
          tmpAnno.title = anno.words;
          tmpAnno.classIds = [];
        }
        return tmpAnno;
      });
      this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
      this.getClassInfo();
      if (this.imageStatus < 4) {
        this.$notify({
          group: 'foo',
          text: '当前图片处于标注中或审核中，请谨慎操作！',
          type: 'custom-red',
          duration: 1500,
        });
        this.isAble = false;
      }
      if (this.imageStatus === 5) this.isAble = true;
    },
    submit() {
      if (this.imageStatus === 5) this.validImage();
      else this.finishImage();
    },
    validImage() {
      api
        .updateImage({ taskId: this.taskId, imageId: this.imageId, status: 3 })
        .then(() => {
          this.getNewImage();
        })
        .catch(() => {});
    },
    deleteImage() {
      if (!window.confirm(`确认删除图片吗？`)) return;
      api
        .updateImage({ taskId: this.taskId, imageId: this.imageId, status: 1 })
        .then(() => {
          this.getNewImage();
        })
        .catch(() => {});
    },
    finishImage() {
      if (this.mode === 1 && this.isAble) {
        if (this.orgAnnos.some(v => v.status === 2)) {
          this.$notify({
            group: 'foo',
            text: '存在未确认的异常标注',
            type: 'custom-red',
            duration: 1500,
          });
          return;
        }
        api
          .finishImageAdmin({ taskId: this.taskId, imageId: this.imageId })
          .then(() => {
            this.url = '';
            this.currAnno = {};
            this.currClasses = [];
            this.sceneText = '';
            this.annos = [];
            this.searchImageId = null;
          })
          .catch(() => {});
      }
    },
    updateAnno() {
      if (this.compareAnno() && this.currOperation !== 'words') {
        this.mode = 1;
        this.currClasses = [];
        this.sceneText = '';
        this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
        this.saveAnnoAble = false;
      } else {
        let anno = {
          taskId:
            this.taskId ||
            this.taskList.find(task => task.classes.map(v => v.classId).includes(this.currClasses[0])).taskId,
          imageid: this.imageId,
          annotationId: this.currAnno.id,
          points: this.currAnno.data.map(v => v.map(v => v.map(v => Math.round(v)))),
          classIds: this.currClasses,
        };
        if (this.taskTypeName === '文本矩形' || this.taskTypeName === '文本多边形') anno.words = this.sceneText;
        api
          .saveAnno(anno)
          .then(() => {
            let tmpAnno = {
              id: this.currAnno.id,
              type: this.currAnno.type,
              cat: this.currClasses[0],
              title: this.currClasses.map(v => this.classes[v]).join(','),
              classIds: this.currClasses,
              data: this.currAnno.data,
              userId: this.$store.state.userId,
              annotator: this.currAnno.annotator,
              approver: this.currAnno.modifier,
              createAt: this.currAnno.createAt,
              updateAt: this.currAnno.updateAt,
              status: 3,
            };
            if (this.taskTypeName === '文本矩形' || this.taskTypeName === '文本多边形') {
              tmpAnno.words = this.sceneText;
              tmpAnno.title = this.sceneText;
              tmpAnno.cat = 0;
            }
            this.$set(
              this.orgAnnos,
              this.orgAnnos.findIndex(v => v.id === this.currAnno.id),
              tmpAnno,
            );
            if (this.currOperation !== 'words') {
              this.annos = JSON.parse(JSON.stringify(this.orgAnnos));
              this.mode = 1;
              this.sceneText = '';
              this.currClasses = [];
              this.currAnno = {};
            } else {
              this.nextAnno();
            }
            this.saveAnnoAble = false;
          })
          .catch(() => {
            this.saveAnnoAble = false;
          });
      }
    },
  },
};
</script>
<style scoped>
input {
  margin: 0px 12px;
}
button {
  margin: 0px;
  height: 38px;
}
.approve-btn {
  position: absolute;
  right: 0px;
  bottom: 12px;
}
.approve-btn div button:first-child {
  width: 100px;
  margin-right: 40px;
}
.approve-btn div button:last-child {
  width: 60px;
}
.approve-content {
  height: 646px;
  position: relative;
}
.approve-image {
  box-sizing: border-box;
  margin-right: 224px;
}
.anno-option {
  position: absolute;
  right: 0px;
  top: 0px;
  width: 200px;
  height: 588px;
  padding-top: 10px;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  background: #fafafa;
  overflow: scroll;
}
.annotate-text {
  padding: 0px;
}
.annotate-text textarea {
  resize: none;
  width: 198px;
  height: 586px;
  padding: 8px;
  box-sizing: border-box;
  font-size: 18px;
}
.approve-container {
  padding: 0px 50px 24px;
  width: 100%;
  box-sizing: border-box;
}
.approve-title {
  position: relative;
  margin: 16px 0px;
  font-size: 14px;
}
.approve-title div {
  display: inline-block;
}
.approve-title span {
  margin: 0px 18px;
  color: #333333;
}
button.active {
  background-color: #5d89c0;
  color: #ffffff;
}
.mode-btn {
  display: inline-block;
  /*float: right;
  margin-right: 224px;*/
}
.mode-btn button {
  margin-left: 20px;
  width: 100px;
  outline: none;
}
.approve-title button {
  /*width: 57px;*/
  height: 30px;
  /*margin: 0px;*/
}
.approve-title .anno-belonger {
  padding-left: 6px;
}
.approve-title .anno-info {
  position: absolute;
  right: 0px;
}
.approve-title .anno-search {
  width: 198px;
  height: 34px;
  border: 1px solid #dddddd;
  border-radius: 4px;
  margin-left: 6px;
}
.approve-title .anno-search input {
  border: none;
  height: 34px;
  width: 163px;
  border-radius: 4px 0px 0px 4px;
  border-right: 1px solid #dddddd;
  margin: 0px;
  padding: 10px 12px;
  box-sizing: border-box;
  font-size: 14px;
}
.approve-title .anno-search img {
  width: 14px;
  height: 14px;
  padding: 10px;
  vertical-align: top;
}
.class-option {
  display: block;
  cursor: pointer;
  padding: 6px 12px;
  font-size: 14px;
}
.class-option.exist {
  background: rgba(93, 137, 192, 0.15);
}
.class-option.active {
  background: rgba(93, 137, 192, 0.4);
}
.category-option:last-child .separate-line {
  display: none;
}
.separate-line {
  border-top: 1px dashed #bbbbbb;
  margin: 6px;
}
.flip-button {
  position: absolute;
  font-weight: bold;
  font-size: 20px;
  right: 225px;
  top: 50px;
  z-index: 999;
}
.flip-button > span {
  display: inline-block;
  margin: 0px 10px;
  padding: 0px;
  cursor: pointer;
}
.icp-info {
  padding-top: 12px;
  text-align: center;
  font-size: 14px;
  color: #333333;
}
.icp-info {
  display: block;
  padding-top: 12px;
  text-align: center;
  font-size: 14px;
  color: #333333;
}
.loading {
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 9999;
  background-color: #3333;
}
.loading img {
  position: absolute;
  left: 40%;
  width: 20%;
  top: 20%;
}
</style>
